import React from 'react';
import { MarketOpportunity } from '../components/MarketOpportunity';
import { BusinessModel } from '../components/BusinessModel';
import { GrowthRoadmap } from '../components/GrowthRoadmap';
import { FundraiseSection } from '../components/FundraiseSection';
import { LeadershipSection } from '../components/LeadershipSection';
import { TractionSection } from '../components/TractionSection';
import { VisionSection } from '../components/VisionSection';
export function InvestorsPage() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-368">
      {/* Navigation */}
      <nav className="sticky top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto bg-ivory/95 backdrop-blur-sm border-b border-charcoal/5" data-id="element-369">
        <a href="/" data-id="element-370">
          <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-8 md:h-10" data-id="element-371" />
        </a>
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-372">
          <a href="/" className="hover:text-purple-700 transition-colors" data-id="element-373">
            Home
          </a>
          <a href="#platform" className="hover:text-purple-700 transition-colors" data-id="element-374">
            Platform
          </a>
          <a href="#practitioners" className="hover:text-purple-700 transition-colors" data-id="element-375">
            Practitioners
          </a>
          <a href="/investors" className="text-purple-700 font-semibold" data-id="element-376">
            Investors
          </a>
        </div>
      </nav>

      {/* Hero Section for Investors */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-ivory pt-20 pb-20" data-id="element-377">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-200/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" data-id="element-378"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-purple-200/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-breathe" style={{
        animationDelay: '2s'
      }} data-id="element-379"></div>

        <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-380">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full border border-purple-200/60 bg-white/30 backdrop-blur-sm mb-8" data-id="element-381">
            <span className="text-sm font-medium tracking-wide uppercase text-charcoal/80" data-id="element-382">
              Investment Opportunity
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] mb-8 tracking-tight" data-id="element-383">
            Building the Future of{' '}
            <span className="italic text-charcoal/80" data-id="element-384">Women's Wellness</span>
          </h1>

          <p className="text-lg md:text-xl text-charcoal/70 max-w-3xl mx-auto mb-12 font-light leading-relaxed" data-id="element-385">
            Join us in creating a new category of care — where technology,
            community, and trusted practitioners converge to serve the most
            underserved market in healthcare.
          </p>
        </div>
      </section>

      {/* Investor-focused sections */}
      <MarketOpportunity data-id="element-386" />
      <BusinessModel data-id="element-387" />
      <TractionSection data-id="element-388" />
      <GrowthRoadmap data-id="element-389" />
      <VisionSection data-id="element-390" />
      <LeadershipSection data-id="element-391" />
      <FundraiseSection data-id="element-392" />

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 text-center text-sm border-t border-white/10" data-id="element-393">
        <p data-id="element-394">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
      </footer>
    </main>;
}